import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {ManageStudentsRoutingModule} from "./manageStudents-routing.module";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {TableModule} from "../generic/table/table.module";
import {CourseService} from "../../../service/CourseService";
import {ManageStudents} from "./manageStudents";
import {NgSelectModule} from "@ng-select/ng-select";
import {DlDateTimePickerModule} from "angular-bootstrap-datetimepicker";
import {TutorService} from "../../../service/TutorService";
import {AnalyticsService} from "../../../service/AnalyticsService";
import {NgToggleModule} from "ng-toggle-button";

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ManageStudentsRoutingModule,
        NgxDatatableModule,
        TableModule,
        NgSelectModule,
        DlDateTimePickerModule,
        NgToggleModule,
    ],
  providers: [TutorService, AnalyticsService],
  exports: [
    ManageStudents
  ],
  declarations: [ManageStudents]
})
export class ManageStudentsModule {}
